module.exports = __webpack_public_path__ + "static/media/7C.4808cc41.png";